import { getBlockProps } from "../blocks-parser";

const props = {
  content: {
    source: "html",
    selector: "p,h1,h2,h3,h4,h5,h6",
  },
  structureTag: {
    source: "tag",
    selector: "p,h1,h2,h3,h4,h5,h6",
    default: "p",
  },
};

const paragraphSchema = {
  // Paragraph is a fallback and should be matched last.
  priority: 20,
  selector: "p,h1,h2,h3,h4,h5,h6",
  blockSlug: "grigora/text",
  schema: ({ phrasingContentSchema, isPaste }) => {
    const schema = {
      children: phrasingContentSchema,
      attributes: isPaste ? [] : ["style", "id"],
    };
    return {
      p: schema,
      h1: schema,
      h2: schema,
      h3: schema,
      h4: schema,
      h5: schema,
      h6: schema,
    };
  },
  props,
  transform: (node) => {
    const blockProps = getBlockProps("grigora/text", node.outerHTML, props);

    return {
      blockSlug: "grigora/text",
      blockProps: blockProps,
    };
  },
};

export { paragraphSchema };
